import React, { FC } from 'react';
import SectionTitle from './SectionTitle';
import { projects } from '../data/profile';

const Projects: FC = () => (
  <section id="projetos" className="section section--alt">
    <div className="container">
      <SectionTitle
        eyebrow="Web & sistemas"
        title="Projetos web em destaque"
        subtitle="Plataformas completas construídas com React/Next.js e Firebase."
      />
      <div className="grid grid--2">
        {projects.map((p, i) => (
          <article key={p.title} className="card project reveal" style={{ transitionDelay: `${i * 70}ms` }}>
            <span className="project__n" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
            <h3>{p.title}</h3>
            <p>{p.text}</p>
            <ul className="project__tags">
              {p.tags.map((t) => (
                <li key={t} className="chip chip--sm">{t}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
